module.exports = __webpack_public_path__ + "img/user-left-01.e0d7a13d.svg";